import React from 'react';
import SeoPageContext from 'components/SeoPage/SeoPageContext';
import useSeoPageState from 'components/SeoPage/useSeoPageState';

const SeoPageProvider = ({ children }) => {
  const state = useSeoPageState();

  return <SeoPageContext.Provider value={state}>{children}</SeoPageContext.Provider>;
};

export default SeoPageProvider;
